module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av264-aeddd4605feaec0e689e68066c2bc882.jpg";